/* Ancona Pass 20 — Exact Variant Continuity (ancona-variant.js)
   Keeps the PDP Save (#AnconaSaveBtn) and Compare (#AnconaCompareBtn) buttons'
   data-url + data-price attributes in sync with the shopper's CURRENTLY-SELECTED
   public variant. Because the existing Pass 12 innovation.js (Save) and Pass 13
   launch.js (Compare) read those data attributes AT CLICK TIME, the exact variant
   (canonical product URL + ?variant=<id> + its displayed price) then travels
   automatically through Save, Compare, the header hub, the shareable shortlist,
   inquiry context, and product print/share — with NO edits to those frozen files.

   Fully additive + isolated: this reads only PUBLIC storefront DOM (the product
   form's [name="id"] + the visible price). On ANY failure it does nothing, so
   Save/Compare simply fall back to product-level data (exactly today's behavior)
   — it can only improve, never break, the captured record. No storage, no network,
   no PII. Flag: this <script> tag's data-ancona-variant attribute (empty = off).
   Revert: remove the two data-ancona-variant lines in layout/theme.liquid + this file.

   Ancona Pass 25 additions (remove each marked block below to revert):
   - A1: sync() also mirrors the settled price into the mobile sticky bar's
     [data-ancona-price] hook and mirrors the REAL add-to-cart button's
     disabled state + label (Add to cart / Sold out) onto .ancona-sticky-atc__btn,
     so the bar can never show a stale price or a silently dead button.
   - A8: when the saved entry for this product (ancona:v1:saved, written by the
     frozen innovation.js) points at a DIFFERENT variant than the current
     selection, an explicit "Update saved piece to this length" secondary action
     appears next to the Save button and rewrites that entry in localStorage
     (same {h,u,t,p,i,ts} shape, cap 24). This is the ONLY storage write in this
     layer and it happens only on that explicit click — the frozen files stay
     untouched (their handle-keyed toggle would otherwise DELETE the item).

   Price freshness: Dawn re-renders the price ASYNCHRONOUSLY after a variant change
   (a section fetch, signalled via its pub/sub, not a DOM change event). A single
   sync right after the change would capture the NEW variant id with the OLD price.
   So the price is re-read three ways that converge on the settled value: (a) a
   scoped MutationObserver on the price node fires when Dawn rewrites it, (b) short
   deferred re-syncs cover node-replacement the observer might miss, (c) Dawn's
   pub/sub variant event is used as an extra trigger when present. */
(function () {
  'use strict';
  if (window.__anconaVariant) return;
  window.__anconaVariant = true;

  var script = document.currentScript;
  var flag = script ? script.getAttribute('data-ancona-variant') : null;
  if (flag === '') return; /* explicit empty string disables */
  if (location.pathname.indexOf('/products/') === -1) return; /* PDP only */

  function q(sel, root) { try { return (root || document).querySelector(sel); } catch (e) { return null; } }

  function productForm() {
    return q('form[action*="/cart/add"]') || q('product-form form') || q('product-info form');
  }

  /* The current public variant id (Dawn keeps the form's hidden [name="id"] in sync
     with the selected variant). Digits only — never trust arbitrary input. */
  function selectedVariantId() {
    var f = productForm();
    var idEl = (f && f.querySelector('[name="id"]')) || q('product-info [name="id"]') || q('[name="id"]');
    var v = idEl && idEl.value != null ? String(idEl.value).replace(/[^0-9]/g, '') : '';
    return v && v.length >= 6 ? v : '';
  }

  /* A real, changeable variant picker is present (multi-variant product). */
  function hasPicker() {
    return !!q('variant-selects, variant-radios, .product-form__input input[type="radio"], .product-form__input select');
  }

  function priceScope() { return q('.product__info-container') || q('product-info') || document; }

  /* The stable node whose contents Dawn rewrites on variant change. */
  function priceNode() {
    var scope = priceScope();
    return scope.querySelector('[id^="price-"]') || scope.querySelector('.price') || null;
  }

  /* The current displayed price (Dawn re-renders it on variant change). */
  function currentPrice() {
    var scope = priceScope();
    var el = scope.querySelector('.price-item--sale:not([hidden])') ||
             scope.querySelector('.price-item--regular:not([hidden])') ||
             scope.querySelector('.price-item--regular') ||
             scope.querySelector('.price .price-item') ||
             scope.querySelector('.price');
    var t = el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return t.slice(0, 24);
  }

  /* --- Ancona Pass 25: A1 — sticky-bar truth mirror. Remove this block (and its
     sync() call) to revert. ---------------------------------------------------- */
  function realAtcButton() {
    return q('product-form button[name="add"]') || q('form[action*="/cart/add"] button[name="add"]') || q('button[name="add"]');
  }
  function syncStickyBar(price) {
    var bar = q('.ancona-sticky-atc');
    if (!bar) return;
    var priceEl = bar.querySelector('[data-ancona-price]');
    if (priceEl && price) priceEl.textContent = price;
    var proxy = bar.querySelector('.ancona-sticky-atc__btn');
    var real = realAtcButton();
    if (!proxy || !real) return;
    var off = !!real.disabled || real.getAttribute('aria-disabled') === 'true';
    proxy.disabled = off;
    if (off) proxy.setAttribute('aria-disabled', 'true');
    else proxy.removeAttribute('aria-disabled');
    /* Dawn keeps the visible label in the button's first <span> ("Add to cart" /
       "Sold out" / "Unavailable"); mirror it verbatim so the bar always tells
       the truth in the theme's own lexicon. */
    var span = real.querySelector('span');
    var label = ((span ? span.textContent : real.textContent) || '').replace(/\s+/g, ' ').trim();
    if (label) proxy.textContent = label;
  }

  /* --- Ancona Pass 25: A8 — saved-variant continuity. Remove this block (its
     sync() call and the boot() listeners) to revert. --------------------------- */
  function savedStore() {
    try {
      var v = JSON.parse(window.localStorage.getItem('ancona:v1:saved') || '[]');
      return Array.isArray(v) ? v : null;
    } catch (e) { return null; }
  }
  function syncSavedMismatch() {
    var btn = document.getElementById('AnconaSaveBtn');
    var wrap = btn && btn.closest ? btn.closest('.ancona-save') : null;
    if (!btn || !wrap || wrap.hidden) return; /* Saved feature off / storage denied */
    var handle = btn.getAttribute('data-handle');
    var curUrl = btn.getAttribute('data-url') || '';
    if (!handle || !curUrl) return;
    var list = savedStore();
    var entry = null;
    if (list) {
      list.some(function (x) {
        if (x && x.h === handle && typeof x.u === 'string') { entry = x; return true; }
        return false;
      });
    }
    var mismatch = !!entry && entry.u !== curUrl;
    var upd = document.getElementById('AnconaSavedUpdate');
    if (!mismatch) { if (upd) upd.hidden = true; return; }
    if (!upd) {
      upd = document.createElement('button');
      upd.type = 'button';
      upd.id = 'AnconaSavedUpdate';
      upd.className = 'ancona-save__update';
      upd.textContent = 'Update saved piece to this length';
      var status = document.createElement('span');
      status.id = 'AnconaSavedUpdateStatus';
      status.className = 'ancona-save__update-status';
      status.setAttribute('role', 'status');
      btn.insertAdjacentElement('afterend', upd);
      upd.insertAdjacentElement('afterend', status);
      upd.addEventListener('click', function () {
        try {
          var l = savedStore();
          if (!l) return;
          var saveBtn = document.getElementById('AnconaSaveBtn');
          var target = saveBtn ? (saveBtn.getAttribute('data-url') || '') : '';
          var p = saveBtn ? (saveBtn.getAttribute('data-price') || '') : '';
          if (!target) return;
          var changed = false;
          l.forEach(function (x) {
            if (x && x.h === handle) {
              x.u = target;
              if (p) x.p = p.slice(0, 24);
              x.ts = Date.now();
              changed = true;
            }
          });
          if (!changed) return;
          window.localStorage.setItem('ancona:v1:saved', JSON.stringify(l.slice(0, 24)));
          upd.hidden = true;
          var st = document.getElementById('AnconaSavedUpdateStatus');
          if (st) st.textContent = 'Saved piece updated.';
        } catch (e) { /* storage failure: leave the existing entry untouched */ }
      });
    }
    var st2 = document.getElementById('AnconaSavedUpdateStatus');
    if (st2) st2.textContent = '';
    upd.hidden = false;
  }

  function sync() {
    try {
      var vid = selectedVariantId();
      var picker = hasPicker();
      var price = currentPrice();
      ['AnconaSaveBtn', 'AnconaCompareBtn'].forEach(function (id) {
        var btn = document.getElementById(id);
        if (!btn) return;
        var handle = btn.getAttribute('data-handle');
        if (!handle) return;
        /* Preserve whatever path the frozen Liquid rendered (product.url, which
           already carries any active locale/market prefix) rather than hardcoding
           '/products/'. Strip any query/hash we appended on a prior sync first. */
        var cur = btn.getAttribute('data-url') || ('/products/' + handle);
        var base = cur.split('?')[0].split('#')[0];
        /* Append ?variant only for a genuine multi-variant selection; single-variant
           ("Default Title") products keep the plain product URL (today's behavior). */
        btn.setAttribute('data-url', (vid && picker) ? (base + '?variant=' + vid) : base);
        if (price) btn.setAttribute('data-price', price);
      });
      /* Ancona Pass 25: A1 + A8 (see the marked blocks above). */
      syncStickyBar(price);
      syncSavedMismatch();
    } catch (e) { /* never break the PDP */ }
  }

  var pending = null;
  function schedule() { if (pending) return; pending = window.setTimeout(function () { pending = null; sync(); }, 60); }

  /* After a variant change, re-read a few times so the async price re-render is
     captured even if the observer misses a full node replacement. */
  function scheduleSettled() {
    schedule();
    window.setTimeout(sync, 350);
    window.setTimeout(sync, 750);
  }

  var mo = null;
  function observePrice() {
    if (typeof MutationObserver !== 'function') return;
    var node = priceNode();
    if (!node) return;
    try {
      if (mo) mo.disconnect();
      mo = new MutationObserver(function () { schedule(); });
      /* childList/characterData only — never attributes — so writing data-* on the
         Save/Compare buttons can never re-trigger this observer (no feedback loop). */
      mo.observe(node, { childList: true, subtree: true, characterData: true });
    } catch (e) { /* observation is best-effort */ }
  }

  function boot() {
    sync();
    observePrice();
    /* Dawn updates the hidden id + price on variant change; capture broadly + safely. */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"]')) scheduleSettled();
    }, true);
    ['variant:change', 'variantChange', 'on:variant:change'].forEach(function (ev) {
      try { document.addEventListener(ev, scheduleSettled, true); } catch (e) {}
    });
    /* Dawn's own pub/sub variant event, when its subscribe() is exposed globally. */
    try { if (typeof window.subscribe === 'function') window.subscribe('variant-change', scheduleSettled); } catch (e) {}
    window.addEventListener('popstate', scheduleSettled);
    document.addEventListener('shopify:section:load', function () { observePrice(); scheduleSettled(); });
    /* Ancona Pass 25: A8 — the frozen layers dispatch these on save/unsave; re-check
       the mismatch affordance so it never lingers after an unsave. Remove to revert. */
    ['ancona:saved_add', 'ancona:saved_remove'].forEach(function (ev) {
      try { document.addEventListener(ev, function () { try { syncSavedMismatch(); } catch (e) {} }); } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
